export default __webpack_public_path__ + "static/media/review-preamble.f55c58c0.md";